import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, TemplateRef } from '@angular/core';
import { TableConfig } from '../../entities/table-config';
import {fromEvent, Observable, iif} from 'rxjs';
import {HttpService} from '../../services/http/http-service.service';
import {CommonService} from '../../services/common/common.service';

@Component({
  selector: 'app-s-tree-table',
  templateUrl: './s-tree-table.component.html',
  styleUrls: ['./s-tree-table.component.less']
})
export class STreeTableComponent implements OnInit, OnChanges {

  constructor(
    private httpService: HttpService,
    private commonService: CommonService
  ) { }
  @Input() cellContent: TemplateRef<any>;
  @Input() treeObj: TableConfig;
  @Output() currentNode: EventEmitter<any> = new EventEmitter();
  // 表头信息
  columns: any = [];
  /** 表格数据 */
  pageRecords: any[] = [];
   /* *加载状态 */
  loading = false;
  /** 表格滚动参数 */
  scroll: any = {x: '100%', y: '500px'};
  right = false;
  /** 固定项宽度,选项、单选、多选 */
  fixedItem: any = '60px';
  pageData: any = {page:  1, pageSize: 50, total: 0};
  params: any = {};
  activeKey: any;
  listOfMapData: any[] =  [
    {
      name: '1',
      age: 60,
      address: '1',
      children: [
        {
          name: '11',
          age: 42,
          address: '11'
        },
        {
          name: '12',
          age: 30,
          address: '12',
          children: [
            {
              name: '121',
              age: 16,
              address: '121'
            }
          ]
        },
        {
          name: '13',
          address: '13',
          children: [
            {
              name: '131',
              age: 42,
              address: '131',
              children: [
                {
                  name: '1311',
                  age: 25,
                  address: '1311'
                },
                {
                  name: '1312',
                  age: 18,
                  address: '1312'
                }
              ]
            }
          ]
        }
      ]
    },
    {
      name: '1',
      age: 32,
      address: '1'
    }
  ];
  mapOfExpandedData: { [key: string]: TableConfig[] } = {};
  ngOnInit(): void {
    this.columns = this.treeObj.columns;
    this.setKey(this.listOfMapData, 0);
    this.listOfMapData.forEach(item => {
      this.mapOfExpandedData[item.key] = this.convertTreeToList(item);
    });
    this.initTableWidth();
    this.windResize();
  }

  ngOnChanges(changes: SimpleChanges): void {
      // this.changesLoadTable(changes);
  }
  changesLoadTable(changes) {
    if (!changes.treeObj.currentValue) {
      return;
    }
    this.treeObj = changes.treeObj.currentValue;
    if (this.treeObj.tableData) {
      this.getLocalDatas();
    } else {
      this.getDynamicHeaders();
      this.getTableData();
    }
    this.windResize();
  }

  getLocalDatas() {
    this.setDefaultAttr();
    this.listOfMapData = this.treeObj.tableData || [];
    this.columns = this.treeObj.columns;
    this.initTableWidth();
  }

  initParams() {
    const params = {};
    if (this.treeObj.isPage) {
      Object.defineProperties(params, {
        pageSize: {value: this.pageData.pageSize, enumerable: true},
        page: {value: this.pageData.page, enumerable: true}
      });
    }
    if (this.treeObj.tableParams && Object.keys(this.treeObj.tableParams).length) {
      for (const key in this.treeObj.tableParams) {
        if (this.treeObj.tableParams.hasOwnProperty(key)) {
          if (this.treeObj.tableParams[key]) {
            Object.defineProperty(params, key, {value: this.treeObj.tableParams[key], enumerable: true});
          }
        }
      }
    }
    this.params = params;
  }

  async getDynamicHeaders() {
    if (this.treeObj.titleUrl && this.treeObj.titleParams) {
      this.getDynamicHeaders();
    }
    const res = await this.httpService.httpPost(this.treeObj.titleUrl, this.treeObj.titleParams).toPromise();
    if (res.code === 1 && res.MapperList && res.MapperList.length) {
      this.initDynamicHeaders(res.MapperList);
    }
  }
  initDynamicHeaders(mapperList) {
    mapperList.forEach((item) => {
      if (item.PropertyName) {
        const temp = {header: '', name: '', type: '', width: ''};
        temp.header = item.ShowName;
        temp.name = item.PropertyName;
        if (item.ShowFormatter) {
          temp.type = item.ShowFormatter.type;
          temp.width = item.ShowFormatter.width;
          if (item.ShowFormatter.isTemplete === 'true') {
            Object.defineProperty(temp, 'isTemplete', {value: true, enumerable: true});
          }
        }
        this.columns.push(temp);
      }
    });
    if (this.treeObj.isOperation) {
      this.columns.push(this.treeObj.operationObj);
    }
    this.initTableWidth();
  }

  async getTableData() {
    if (this.treeObj.tableUrl) {
      if (this.treeObj.defaultLoad) {
        this.initParams();
        this.loading = true;
        const res = await this.httpService.httpGet(this.treeObj.tableUrl, this.params).toPromise();
        if (res.code === 1) {
          this.inintTableDatas(res);
        }
        this.loading = false;
      } else {
        this.pageRecords = [];
      }
    }
  }

  inintTableDatas(res) {
    this.inintTableDatas(res);
    this.pageData.total = res.data.totalCount;
    this.listOfMapData = res.data.data;
    this.setKey(this.listOfMapData, 0);
    this.listOfMapData.forEach(item => {
      this.mapOfExpandedData[item.key] = this.convertTreeToList(item);
    });
  }

  setKey(data, pid) {
    data.forEach((item, index) => {
      if (this.treeObj.isExpandAll) {
        Object.defineProperty(item, 'expanded', {value: true, enumerable: true, writable: true});
      }
      let pid1 = index + 1;
      if (pid) {
       pid1 = Number(String(pid) + String(pid1));
      }
      item.key = pid1;
      item.active = false;
      item.checked = false;
      if (item.children) {
       this.setKey(item.children, pid1);
      }
    });
  }


  setAttributes(data, pid) {
    data.forEach((item, index) => {
      if (this.treeObj.isExpandAll) {
       Object.defineProperty(item, 'expanded', {value: true, enumerable: true, writable: true});
      }
      item.active = false;
      item.checked = false;
      let pid1 = index + 1;
      if (pid) {
       pid1 = Number(String(pid) + String(pid1));
      }
      item.key = pid1;
      if (data.children && data.children.length) {
        this.setAttributes(data.children, pid1);
      }
    });
  }

  collapse(array: TableConfig[], data: TableConfig, $event: boolean): void {
    if (!$event) {
      if (data.children) {
        data.children.forEach(d => {
          const target = array.find(a => a.key === d['key']) !;
          target.expanded = false;
          this.collapse(array, target, false);
        });
      } else {
        return;
      }
    } else {
      this.currentNode.emit(data);
    }
  }

  convertTreeToList(root: any): any[] {
    const stack: any[] = [];
    const array: any[] = [];
    const hashMap = {};
    let tempExpand = false;
    if (this.treeObj && this.treeObj.isExpandAll) {
      tempExpand = true;
    }
    stack.push({ ...root, level: 0, expanded: tempExpand, active: false, checked: false });
    while (stack.length !== 0) {
      const node = stack.pop()!;
      this.visitNode(node, hashMap, array);
      if (node.children) {
        for (let i = node.children.length - 1; i >= 0; i--) {
          stack.push({ ...node.children[i], level: node.level! + 1, expand: false, parent: node });
        }
      }
    }
    return array;
  }

  visitNode(node: TableConfig, hashMap: { [key: string]: boolean }, array: TableConfig[]): void {
    if (!hashMap[node.key]) {
      hashMap[node.key] = true;
      array.push(node);
    }
  }
  initTableWidth() {
    let sum = 0;
    const reg = new RegExp('px', 'g');
    const clientWidth = document.body.clientWidth;
    if (this.treeObj.radioCheck || this.treeObj.comCheck || this.treeObj.showRowNum) {
      sum = 60;
    }
    this.columns.forEach((item) => {
     let width: any = item.width;
     if (typeof width === 'string') {
       if (width.indexOf('px') === -1) {
         sum += parseInt(width, 0);
         item.width =  `${item.width}px`;
       } else {
         width = width.toString().replace(reg, '');
         sum += parseInt(width, 0);
       }
     }
    });
    if (clientWidth < sum + 20) {
      this.scroll.x = `${sum + 20}px`;
    } else {
       this.scroll.x = '100%';
    }
  }

  windResize() {
    fromEvent(window, 'resize').subscribe((e) => {
      if (e.isTrusted) {
        this.initTableWidth();
      }
    });
  }
  /** 组件内部自定义内容 */
  outCellContext(key, value, record) {
    return {
      $implicit: key,
      value,
      record
    };
  }

  rowClick(key) {
    //
    this.activeKey = key;
    this.setRowActive(this.listOfMapData);
    // console.log(this.mapOfExpandedData[key]);
    // this.mapOfExpandedData[key].forEach((item) => {
    //   if (item.key === key) {
    //     item.active = true;
    //     item.checked = true;
    //   }
    // });
  }

  setRowActive(list) {
    for (let i = 0; i < list.length; i++) {
      list[i].active = list[i].checked = false;
      if (list[i].key === this.activeKey) {
        list[i].active = list[i].checked = true;
        // this.mapOfExpandedData[this.activeKey];
        break;
      }
      if (list[i].children && list[i].children.length) {
        this.setRowActive(list[i].children);
      }
    }
  }
  setDefaultAttr() {
    this.treeObj.defaultLoad = this.commonService.isNull(this.treeObj.defaultLoad) ? this.treeObj.defaultLoad : true;
    this.treeObj.isPage = this.commonService.isNull(this.treeObj.isPage) ? this.treeObj.defaultLoad : true;
    if (this.treeObj.isPage) {
      this.pageData.page = this.treeObj.page ? this.treeObj.page : 1;
      this.pageData.pageSize = this.treeObj.pageSize ? this.treeObj.pageSize : 50;
    }
    this.treeObj.isOperation = this.commonService.isNull(this.treeObj.isOperation) ? this.treeObj.isOperation : false;
    this.addOperationItem();
  }
  addOperationItem() {
    if (this.treeObj.isOperation) {
      let oWidth = '200px';
      if (this.treeObj.operationWidth) {
        oWidth = this.treeObj.operationWidth;
      }
      this.treeObj.operationObj = {
        name: 'operation', header: '操作',
        attrs: {width: oWidth, isTemplete: true, isOperation: true, isRight: true}
      };
      setTimeout(() => {
        this.right = true;
      });
    }
  }
}
